import { useRef } from 'react';
import { deepEqual } from 'shared/utils/deepEqual';

/**
 * this hooks uses state to store a key value object. it only changes that object
 * when the _value_ of that object changes. this avoids unnecessary re-renders
 * due to using these objects within hook dependency arrays.
 */
export const useValueEquivalentKeyValuesObject = (
  keyValueObj: Record<string, unknown> | null,
): Record<string, unknown> | null => {
  const valueRef = useRef<Record<string, unknown> | null>(null);

  const hasDiff = !deepEqual(keyValueObj, valueRef.current);
  if (hasDiff) {
    valueRef.current = keyValueObj;
  }

  return valueRef.current;
};
